import {
  FlowGetAgentConversationConfigSchema,
  FlowGetAssistantConfigSchema,
  FlowGetEncounterContactsConfigSchema,
  FlowGetEncountersConfigSchema,
  FlowGetExternalDocumentPacketConfigSchema,
  FlowGetFeedMessagesConfigSchema,
  FlowGetGuarantorConfigSchema,
  FlowGetHl7MessageEventConfigSchema,
  FlowGetInsuranceOcrResultsConfigSchema,
  FlowGetJobContextConfigSchema,
  FlowGetPatientConfigSchema,
  FlowGetPatientInsuranceInformationConfigSchema,
  FlowGetPatientOrderConfigSchema,
  FlowGetPatientUploadConfigSchema,
  FlowGetPaymentConfigSchema,
  FlowGetPracticeConfigSchema,
  FlowGetPrimaryCareProviderConfigSchema,
  FlowGetReferenceTableConfigSchema,
  FlowGetSftpMessageEventConfigSchema,
  FlowGetTemplateConfigSchema,
  FlowGetX12MessageEventConfigSchema,
  FlowNotableObject,
} from 'flow-schema';
import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BaseNotableObjectConfigSchema,
  BlockType,
} from '../base/baseSchema.js';
import { ProviderIDType } from '../getProvider/config.js';

export const MAX_JOB_CONTEXT_LIMIT = 25;

export const GetProviderConfigSchema = BaseNotableObjectConfigSchema.extend({
  notableObject: z.literal(FlowNotableObject.Provider),
  providerIdType: z.enum(ProviderIDType).optional(),
  isSelectMultipleProviderIdsEnabled: z.boolean().default(false),
  providerId: z.string().optional(),
});

export const GetNotableObjectConfigSchema = z.discriminatedUnion('notableObject', [
  FlowGetReferenceTableConfigSchema,
  FlowGetPaymentConfigSchema,
  FlowGetAgentConversationConfigSchema,
  FlowGetHl7MessageEventConfigSchema,
  FlowGetGuarantorConfigSchema,
  FlowGetPatientOrderConfigSchema,
  GetProviderConfigSchema,
  FlowGetTemplateConfigSchema,
  FlowGetExternalDocumentPacketConfigSchema,
  FlowGetPatientConfigSchema,
  FlowGetPracticeConfigSchema,
  FlowGetSftpMessageEventConfigSchema,
  FlowGetX12MessageEventConfigSchema,
  FlowGetPatientUploadConfigSchema,
  FlowGetPatientInsuranceInformationConfigSchema,
  FlowGetEncountersConfigSchema,
  FlowGetPrimaryCareProviderConfigSchema,
  FlowGetFeedMessagesConfigSchema,
  FlowGetEncounterContactsConfigSchema,
  FlowGetInsuranceOcrResultsConfigSchema,
  FlowGetJobContextConfigSchema,
  FlowGetAssistantConfigSchema,
]);

export type GetNotableObjectConfig = z.infer<typeof GetNotableObjectConfigSchema>;

export const GetNotableObjectBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.GetNotableObject),
  config: GetNotableObjectConfigSchema,
});

export type GetNotableObjectBlock = z.infer<typeof GetNotableObjectBlockSchema>;
